import { useState } from "react";
import { Tooltip } from "ui/popovers/Tooltip";
import Checkbox from "./Checkbox";

export function Wrapper({ children }) {
  return <Tooltip.Provider>{children}</Tooltip.Provider>;
}

<Wrapper>

## Basic Usage

export function BasicCheckbox() {
  const [checked, setChecked] = useState(false);
  return <Checkbox label="I agree to the terms" checked={checked} onChangeBoolean={setChecked} />;
}

<BasicCheckbox />

---

## Indeterminate State (Parent-Child)

export function IndeterminateCheckbox() {
const [items, setItems] = useState({ item1: false, item2: true, item3: false });
const allChecked = Object.values(items).every(Boolean);
const someChecked = Object.values(items).some(Boolean);
const checkedState = allChecked ? true : someChecked ? "indeterminate" : false;
return (

<div>
  <Checkbox
    label="Select All"
    checked={checkedState}
    onCheckedChange={(c) => typeof c === "boolean" && setItems({ item1: c, item2: c, item3: c })}
  />
  <div style={{ marginLeft: "24px", marginTop: "8px", display: "flex", flexDirection: "column", gap: "8px" }}>
    <Checkbox label="Item 1" checked={items.item1} onChangeBoolean={(c) => setItems((p) => ({ ...p, item1: c }))} />
    <Checkbox label="Item 2" checked={items.item2} onChangeBoolean={(c) => setItems((p) => ({ ...p, item2: c }))} />
    <Checkbox label="Item 3" checked={items.item3} onChangeBoolean={(c) => setItems((p) => ({ ...p, item3: c }))} />
  </div>
</div>
); }

<IndeterminateCheckbox />

---

## Disabled States

<div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
  <Checkbox label="Disabled (unchecked)" checked={false} disabled />
  <Checkbox label="Disabled (checked)" checked disabled />
  <Checkbox label="Disabled (indeterminate)" checked="indeterminate" disabled />
</div>

---

## Locked State

<div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
  <Checkbox label="Locked (checked)" checked locked />
  <Checkbox label="Locked (unchecked)" checked={false} locked />
</div>

Locked checkboxes show a lock icon and cannot be modified.

---

## Read-Only State

<div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
  <Checkbox label="Read-only (checked)" checked readOnly />
  <Checkbox label="Read-only (unchecked)" checked={false} readOnly />
</div>

---

## With Tooltip

export function TooltipCheckbox() {
const [checked, setChecked] = useState(false);
return (

<Checkbox
  label="Enable notifications"
  checked={checked}
  onChangeBoolean={setChecked}
  tooltip="You will receive email notifications"
/>
); }

<TooltipCheckbox />

</Wrapper>
